import { CANNIBALIZATION_ROLLOUT } from "constants/configConstants";

const generateReviewSchemaData = (data: any = {}, meta: any = {}) => {
  const defaulValueIfRatingIsNotPresent = 4;
  const aggregateRating = data?.result?.reduce(
    (acc: any, item: any) => {
      const reviewCount = item?.reviews_count || 1;
      const reviewRating = item?.reviews_rating || defaulValueIfRatingIsNotPresent;
      const count = +reviewCount + acc.count;
      const rating = +reviewRating + acc.rating;
      const weightedRating = +(reviewRating * reviewCount) + acc.weightedRating;
      return { count, rating, weightedRating };
    },
    {
      count: 0,
      rating: 0,
      weightedRating: 0,
    },
  );
  const weightedAvg = Number(
    aggregateRating?.count > 0
      ? (aggregateRating?.weightedRating / aggregateRating.count).toFixed(2)
      : 0,
  );

  const regionName = CANNIBALIZATION_ROLLOUT.includes(
    data?.region?.location?.country?.short_name || "",
  )
    ? data?.region?.name
    : data?.region?.canonical_base_name;

  const defaultSchemaData = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: regionName,
    description: meta?.description || "",
    url: `https://amberstudent.com${meta?.canonical_url_suffix}`,
    sku: data?.region?.canonical_name,
    mpn: "",
    brand: {
      "@type": "Brand",
      name: "amberstudent",
    },
    image: "",
  };

  const schemaData = {
    ...defaultSchemaData,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: weightedAvg >= 3 ? weightedAvg : 3,
      reviewCount: aggregateRating?.count || 1,
      worstRating: 1,
      bestRating: 5,
    },
  };

  return schemaData;
};

export default generateReviewSchemaData;
